import AlertMessage from "../Components/AlertMessage/AlertMessage";
import { GetInvoicesService_NEW, UpdateInvoiceStageAndArchiveStatusService } from "../Services/InvoiceService/InvoiceService";

export const ARCHIEVE_STATUS = {
  ALREADY_EXPORTED: "AlreadyExported",
  UNARCHIEVED: "UnArchived",
  ARCHIEVED: "Archived",
  DEFAULT: "Default",
}

export const INVOICE_STAGES= {
  NEW: 11,
  VIEWED: 12,
  EDITED: 13,
  READY: 21,
  EXPORTED: 22
}

export const useInvoiceActions = () => {

  const getInvoicesInbox = async (payload: { userId: string; stageId: number, invoicearchieveStatus: string }) => {
    const { userId, stageId, invoicearchieveStatus } = payload;
   let apiResponse = await GetInvoicesService_NEW ({
      userId,
      after: null,
      order: "default",
      reversed: false,
      stageIds: [INVOICE_STAGES.NEW, INVOICE_STAGES.VIEWED, INVOICE_STAGES.EDITED, INVOICE_STAGES.READY, INVOICE_STAGES.EXPORTED],
      archiveStatuses: [ARCHIEVE_STATUS.DEFAULT, ARCHIEVE_STATUS.UNARCHIEVED],
      limit: 100,
       });  
  /*
  userId: string;
  after?: string | null;              // cursor for pagination
  order?: string ;                    // "asc" | "desc" or any specific field based on InvoiceFieldMap
  reversed?: boolean;
  stageIds?: number[];
  archiveStatuses?: string[];         // you can make this enum if fixed values
  limit?: number;
  */


   if(apiResponse.Items){
    //Status Check

    return apiResponse.Items

   }
  }
  const getInvoicesToReview = async (payload: { userId: string; stageId: number }) => {}
  const getInvoicesReady = async (payload: { userId: string; stageId: number }) => {}
  const getInvoicesExported = async (payload: { userId: string; stageId: number }) => {}
  const getInvoicesArchived = async (payload: { userId: string; stageId: number }) => {}

  const makeInvoiceViewed = async (
    invoiceIds: number ,
    currentStageId: number,
  ) => {
    try {
      if (currentStageId === 11) {
        await UpdateInvoiceStageAndArchiveStatusService({
          invoiceIds: [invoiceIds], // Ensure this is an array
          stageId: 12,
          archiveStatus: null,
        });
      }
    } catch (error) {
      console.error("Failed to update invoice stage", error);
    }
  };

  const makeInvoiceEdited = async (
    invoiceIds: number[],
    currentStageId: number,
  ) => {
    try {
      if (currentStageId === 12) {
        await UpdateInvoiceStageAndArchiveStatusService({
          invoiceIds,
          stageId: 13,
          archiveStatus: null,
        });
      }
    } catch (error) {
      console.error("Failed to update invoice stage", error);
    }
  };

  const makeInvoicesArchived = async (invoices: { invoiceId: number; invoicearchieveStatus: string| undefined,  invoiceStageId: number|null }[]) => {
try{
    UpdateInvoiceStageAndArchiveStatusService({
         invoiceIds : invoices.map(i => i.invoiceId),//invoices.map(i => i.invoiceId),//validInvoices,//  Ensure this is an array because the service expects an array. The is used to update multipe invoices at once.
          stageId: null,  // TODO:  BE need to imoleent a feature lets lets us keep the original stageID if no chnages are made. 
          archiveStatus: ARCHIEVE_STATUS.ARCHIEVED, //pending work for archive status
        })
//TODO: NEED TO ADD SOME VALIDATIONS HERE 
  
} catch (error) {
    console.error("Failed to update invoice stage", error);
}
  };

  const makeInvoicesUnArchived = async (invoiceIds: number[], currentStageId: number) => {
try{
    await UpdateInvoiceStageAndArchiveStatusService({
          invoiceIds, //  Ensure this is an array because the service expects an array. The is used to update multipe invoices at once.
          stageId: currentStageId,
          archiveStatus: "UnArchived", //pending work for archive status
        });
} catch (error) {}

finally{}

    // future logic
  };

  const makeInvoicesExported = async (invoices: { invoiceId: number; invoicearchieveStatus: string; invoiceStageId: number }[]) =>{
  // alert('makeInvoicesExported')
  AlertMessage({
    text: "Invoices exported successfully",
    type: "success",
  });
  console.log(invoices)
  const ALLOWED_SOURCE_STAGES = [21];
  const ALLOWED_ARCHIVE_STATUSES = ['UnArchived', 'Default'];
//TODO: need to validated the currentInvoiceStageId fir each invoices
    // Validate stage and archive status
  // const isStageAllowed = ALLOWED_SOURCE_STAGES.includes(invoices.stageId);
  // const isArchiveStatusAllowed = ALLOWED_ARCHIVE_STATUSES.includes(invoices.archiveStatus);
  let validInvoices : number[]= []
  invoices.map((invoice) => {
    if (!ALLOWED_SOURCE_STAGES.includes(invoice.invoiceStageId) && !ALLOWED_ARCHIVE_STATUSES.includes(invoice.invoicearchieveStatus)) {
      console.error(`Invoice stage ${invoice.invoiceStageId} is not allowed to move to Exported stage`);
      //TODO: Set An Alert from here mentioning the invoice ID
      return;
    }else {
      validInvoices.push(invoice.invoiceId)
    }
  })

   await UpdateInvoiceStageAndArchiveStatusService({
      invoiceIds: validInvoices, //  Ensure this is an array because the service expects an array. The is used to update multipe invoices at once.
      stageId: INVOICE_STAGES.EXPORTED, //22
      archiveStatus: ARCHIEVE_STATUS.ALREADY_EXPORTED//'UnArchived', //pending work for archive status
    });



}

  const makeInvoiceReady = async (invoiceIds: number[], invoiceStageId: number,
     archiveStatus: string): Promise<void> => {
      
     // Early validation
  if (!invoiceIds?.length) {
    console.error("No invoice IDs provided for moving to Ready stage");
    return;
  }

  // Define business rules
  const ALLOWED_SOURCE_STAGES = [11, 12, 13];
  const ALLOWED_ARCHIVE_STATUSES = ['UnArchived', 'Default'];

  // Validate stage and archive status
  const isStageAllowed = ALLOWED_SOURCE_STAGES.includes(invoiceStageId);
  const isArchiveStatusAllowed = ALLOWED_ARCHIVE_STATUSES.includes(archiveStatus);

//Validation
  if (!ALLOWED_SOURCE_STAGES.includes(invoiceStageId) && !ALLOWED_ARCHIVE_STATUSES.includes(archiveStatus)) {console.error(`Invoice stage ${invoiceStageId} is not allowed to move to Ready stage`);
   return;}

    await UpdateInvoiceStageAndArchiveStatusService({
      invoiceIds,
      stageId: INVOICE_STAGES.READY,
      archiveStatus: null//'UnArchived', //pending work for archive status
    });
    console.log("Invoice moved to Ready stage successfully", invoiceIds);
  };



  return {

    getInvoicesInbox,
    makeInvoiceViewed,
    makeInvoiceEdited,
    makeInvoiceReady,
    makeInvoicesExported,
    makeInvoicesUnArchived,
    makeInvoicesArchived
  };
};
